import React from 'react';

import AppModal from '../../../ui-components/AppModal';
import SystemEmailForm from './SystemEmailForm';

interface SystemEmailFormModalProps {
  isOpen: boolean;
  mode: 'create' | 'edit';
  emailTemplateId?: string;
  onClose: () => void;
  onSuccess?: () => void;
}

const SystemEmailFormModal: React.FC<SystemEmailFormModalProps> = ({
  isOpen,
  mode,
  emailTemplateId,
  onClose,
  onSuccess,
}) => {
  return (
    <AppModal
      isOpen={isOpen}
      title={mode === 'edit' ? 'Edit System Email' : 'Add System Email'}
      description={
        mode === 'create'
          ? 'Create a new System Email'
          : 'Update existing System Email information'
      }
      onClose={onClose}
      hideFooter
      variant="form"
      maxWidth="max-w-3xl"
      closeOnOverlayClick
    >
      <SystemEmailForm
        embedded
        emailTemplateId={emailTemplateId}
        onClose={onClose}
        onSuccess={onSuccess}
      />
    </AppModal>
  );
};

export default SystemEmailFormModal;
